import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import type { EGridDirections } from "./legendsTypes";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const GridBox = styled.div<{
    repeatAmount?: string;
    gap?: string;
    gridDirection?: EGridDirections | string;
}>`
    display: flex;
    flex-wrap: wrap;
    flex-direction: ${({ gridDirection }) => (gridDirection ? gridDirection : "row")};
    ${({ gap }) => gap && `gap: ${gap}`};
`;

export const IconsContainer = styled.div`
    padding-top: 5px;
    padding-left: 4px;
`;

export const InfoIconContainer = styled.div`
    display: flex;
    align-items: center;
    padding-left: 4px;
`;

export const LegendWrapperWithSeparator = styled.div`
    padding-top: 8px;
    width: fit-content;
    border-top: 1px solid ${colorsPalettes.carbon[100]};
`;

export const ScrollWithFadeContainer = styled.div<{ height: string }>`
    overflow-y: hidden;
    height: ${({ height }) => height};
    padding-right: 16px;
    &:hover {
        overflow-y: auto;
    }
`;

export const MainLegendContainer = styled(FlexRow)`
    align-items: center;
`;
